import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { Alert, Pagination } from "@material-ui/lab";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { SearchButton } from "components/searchButton";
import { Wrapper } from "components/wrapper";
import CustomBackdrop from "components/backdrop";
import { UltimaAtualizacao } from "components/ultimaAtualizacao";
import { ExportButtons } from "components/exportButtons";
import { SortDirectionSelect } from "components/sortDirectionSelect";
import { useConselhosState } from "./context/conselhos-context";
import { useConselhosController } from "./context/conselhos-controller";
import { ConselhosTable } from "./conselhosTable.component";

export function ConselhosPage() {
  const { conselhos, conselhoPagedRequest, loading, areas, ultimaAtualizacao, error } = useConselhosState();
  const { onInit, handleOnChange, listConselhos, exportConselhos } = useConselhosController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await listConselhos({ ...conselhoPagedRequest, page: value - 1 }, true);
    })();
  };

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Conselhos" },
        ]}
      />
      <PageTitle>Conselhos</PageTitle>
      <Wrapper>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5}>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="text-field-term"
                  label="Nome do Conselho"
                  value={conselhoPagedRequest?.term || ''}
                  onChange={(e) => handleOnChange(e)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel shrink>Área</InputLabel>
                  <Select
                    name="select-area-id"
                    value={conselhoPagedRequest?.idAreaTransparenciaSetorial || ''}
                    onChange={(e) => handleOnChange(e)}
                    label="Área"
                    displayEmpty
                  >
                    <MenuItem value="">Todas</MenuItem>
                    {areas?.map((a) => (
                      <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SearchButton onClick={() => (async () => {
                  await listConselhos(conselhoPagedRequest, true);
                })()}>
                  <SearchIcon /> Consultar
                </SearchButton>
              </Grid>
              <Grid item xs={12} sm={3}>
                <SortDirectionSelect
                  value={conselhoPagedRequest?.orderDirection}
                  onChange={(e) => handleOnChange(e)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <CustomBackdrop open={loading} />
            <UltimaAtualizacao data={ultimaAtualizacao} />
            <ExportButtons onExport={exportConselhos} />
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <ConselhosTable currentItems={conselhos} />
            )}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3} justifyContent="center">
              <Pagination
                size="large"
                variant="outlined"
                shape="rounded"
                onChange={handlePageClick}
                count={conselhos?.pageCount}
                color="primary"
              />
            </Grid>
          </Grid>
        </Grid>
      </Wrapper>
    </>
  );
}
